export default __webpack_public_path__ + "static/media/NIAS0350.34I-32910_-17927_0.687ab82d.jpg";